import { render, staticRenderFns } from "./getRollbackDetail.vue?vue&type=template&id=3ce14afc&lang=pug"
import script from "./getRollbackDetail.vue?vue&type=script&lang=js"
export * from "./getRollbackDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports